const key = 'cabmun-mini-survey';
type MiniServeyProps = { isDone: boolean; step: number };
type Props = Record<string, MiniServeyProps>;

const defaultMiniServeyProps: MiniServeyProps = { isDone: false, step: 0 };
function set(params: Props) {
  localStorage.setItem(key, JSON.stringify(params));
}

function get(): Props {
  return JSON.parse(localStorage.getItem(key) || '{}');
}

export const getMiniSurveysData = (serveyName: string) => {
  const getted = get();

  return getted[serveyName] ? getted[serveyName] : defaultMiniServeyProps;
};

export const setMiniSurveysData = (
  serveyName: string,
  data: Partial<MiniServeyProps>,
) => {
  const getted = get();
  set({
    ...getted,
    [serveyName]: { ...(getted[serveyName] ? getted[serveyName] : defaultMiniServeyProps), ...data },
  });
};
